import React from 'react'
import { Col, Modal, ModalBody, CardBody, Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
export const ModalViewExamsQuoter = (props) => {

    const {
        modalExams,
        handleToggleExams,
        listExams
    } = props;

    const footer = (
        <div className="profile-modal-footer">
            <Button
                color="primary"
                onClick={handleToggleExams}
            >
                Entendido
            </Button>
        </div>
    );

    return (
        <Dialog
            header={
                <div className="profile-modal-header">
                    <i className="fa fa-cubes"></i>
                    <span>Perfil de Estudios</span>
                </div>
            }
            visible={modalExams}
            onHide={handleToggleExams}
            modal
            closable
            blockScroll
            className="medium-dialog"
            footer={footer}
        >

            <div className="profile-modal-description">
                Los siguientes estudios forman parte del perfil seleccionado.
            </div>

            <div className="profile-exams-list">

                {listExams?.map((_exam, index) => (

                    <div
                        key={`exam-${index}`}
                        className="profile-exam-item"
                    >
                        <div className="profile-exam-icon">
                            <i className="fa fa-flask"></i>
                        </div>

                        <div className="profile-exam-name">
                            {_exam?.name ?? "Sin nombre"}
                        </div>
                    </div>

                ))}

            </div>

        </Dialog>
    );
};